<template>
	<Col class="width-100 height-100 flex-centerize px-5">
		<Col class="email-container width-100">
			<Col class="email-header-container px-4 pt-4 pb-2">
				<div class="new-act mb-1">New Activity</div>
				<div class="display-flex flex-row flex-align-center">
					<div class="mr-1 section-title">From:</div>
					<div class="section-value">{{ sender }}</div>
				</div>
				<div class="display-flex flex-row flex-align-center">
					<div class="mr-1 section-title">To:</div>
					<div class="section-value">{{ recipient }}</div>
				</div>
			</Col>
			<Col class="py-9 px-4">
				<Col class="inner-mail-container pt-6 pb-8 px-4">
					<AppIcon class="mb-6" name="logo-with-text" width="46" height="20" />
					<h3 class="bold mb-2">You’ve received a new notification:</h3>
					<BuilderNotification
						:icon="icon"
						:title="title"
						:additionalInfo="additionalInfo"
						class="builder-notification mb-4"
						:takeActionTitle="takeActionTitle"
					/>
					<AnemicButton class="width-100 take-action-button">{{ takeActionTitle }}</AnemicButton>
				</Col>
				<h5 class="link mt-2">Open in Ply</h5>
			</Col>
		</Col>
	</Col>
</template>

<script>
import BuilderNotification from '@/components/BlockEditorNotification/PreviewTabs/BuilderNotification.vue';
export default {
	name: 'EmailNotificationTab',
	components: { BuilderNotification },
	props: {
		title: { type: String },
		additionalInfo: { type: String },
		takeActionTitle: { type: String },
		sender: { type: String },
		recipient: { type: String },
		notification: { type: Object },
		icon: { type: String, default: 'https://prod-assets.ply.io/icons/bellx1.png' },
	},
};
</script>

<style scoped lang="scss">
$grey-color: #959595;
.new-act {
	font-size: 14px;
	color: $grey-color;
}
.section-title {
	font-size: 12px;
	color: #2c2b2c;
}
.section-value {
	font-size: 12px;
	color: $grey-color;
}

//
//
//
.email-header-container {
	border-bottom: 1px solid var(--border-color);
}
.email-container {
	border: 1px solid var(--border-color);
	border-radius: 5px;
	background: var(--white);
}
.inner-mail-container {
	background: #f7f8fa;
	border-radius: 16px;
}

::v-deep(.builder-notification) {
	.settings-container {
		display: none;
	}
}
.take-action-button {
	height: 30px !important;
	font-size: 12px !important;
	border-radius: 8px !important;
	color: var(--white) !important;
	letter-spacing: 0px !important;
	font-weight: normal !important;
	text-transform: none !important;
	background: #5858ec !important;
}
.link {
	color: #686868;
}
</style>
